import { advancedCodeChallengeProcessServiceModule } from './advanced-code-challenge-process-service';
import { interactUserListComponentModule } from '../../../../../../shared/app/components/interact-user-list/interact-user-list';
import advancedCodeChallengeTemplate from './advanced-code-challenge.tpl.html';
import introDialogTemplate from './advanced-code-challenge.intro.tpl.html';
import { challengeIntroDialogComponentModule } from '../../../../components/challenge-intro-dialog/challenge-intro-dialog';
import { uiRouterStateModule } from '../../../../../../shared/app/vendor/ui-router-module';
import { multiFileChallengeServiceModule } from '../../../../../../shared/app/services/multi-file-challenge-service/multi-file-challenge-service';
import { multiFileLayoutComponentModule } from '../../../../../../shared/app/components/multi-file-layout/multi-file-layout';
import { fileTreeComponentModule } from '../../../../../../shared/app/components/file-tree/file-tree';
import advancedCodeChallengeFileToolbar from './advanced-code-challenge-file-toolbar.tpl.html';
import advancedCodeChallengeFileMenu from './advanced-code-challenge-file-menu.tpl.html';
import mfcDeletedFileMenu from '../../../../../../shared/app/services/multi-file-challenge-service/mfc-deleted-menu.tpl.html';
import './advanced-code-challenge.less';
import { codemirrorOptionsComponentModule } from '../../../../../../shared/app/components/codemirror/codemirror-options';
import { codeFileModelModule } from '../../../../../../shared/app/models/code-file';
import { onConfirmComponentModule } from '../../../../../../shared/app/components/on-confirm/on-confirm';
import { solutionModelModule } from '../../../../../../shared/app/models/solution';
import { appAlertComponentModule } from '../../../../../../shared/app/components/app-alert/app-alert';
import { challengeCodeOfConductComponentModule } from '../../../../../../shared/app/components/challenge-code-of-conduct/challenge-code-of-conduct';
import { horizontalCountdownTimerComponentModule } from '../../../../../../shared/app/components/horizontal-countdown-timer/horizontal-countdown-timer';
import { multiFileToolbarComponentModule } from '../../../../../../shared/app/components/multi-file-toolbar/multi-file-toolbar';
import { attachComponentModule } from '../../../../components/attach-dialog/attach-dialog';
import { attachServiceModule } from '../../../../services/attach-service/attach-service';
import { trackerServiceModule } from '../../../../../../shared/app/services/tracker-service/tracker-service';
import { challengeSubmittingDialogComponentModule } from '../../../../components/challenge-submitting-dialog/challenge-submitting-dialog';
import { insertBefore } from '../../../../../../shared/app/utils/array-utils';
import { bufferedSaveHelperModule } from '../../../../../../shared/app/helpers/buffered-save-helper/buffered-save-helper';
import { isSolutionFilesDiff } from '../../../../../../shared/app/utils/solution-utils';
import { interactEditorButtonComponentModule } from '../../../../../../shared/app/components/interact-editor-button/interact-editor-button';
import { challengeRouteInteractHelperModule } from '../../../../helpers/challenge-route-interact-helper/challenge-route-interact-helper';
import { createInteractParticipantsTab } from '../shared-tabs/interact-participants-tab/interact-participants-tab';

export const advancedCodeChallengeRouteModule = angular
  .module('Q.routes.assessments.challenges.advanced-code-challenge', [
    uiRouterStateModule,
    solutionModelModule,
    advancedCodeChallengeProcessServiceModule,
    appAlertComponentModule,
    challengeCodeOfConductComponentModule,
    interactUserListComponentModule,
    challengeIntroDialogComponentModule,
    multiFileChallengeServiceModule,
    multiFileLayoutComponentModule,
    multiFileToolbarComponentModule,
    fileTreeComponentModule,
    codemirrorOptionsComponentModule,
    codeFileModelModule,
    onConfirmComponentModule,
    horizontalCountdownTimerComponentModule,
    attachComponentModule,
    attachServiceModule,
    trackerServiceModule,
    challengeSubmittingDialogComponentModule,
    bufferedSaveHelperModule,
    interactEditorButtonComponentModule,
    challengeRouteInteractHelperModule,
  ])

  .config(function ($stateProvider) {
    $stateProvider.state('assessments.challenges.advancedCodeChallenge', {
      data: {
        bodyClass: 'assessments challenges advanced-code-challenge',
        label: 'Assessment Challenge IDE',
      },
      resolve: {
        config: /* @ngInject */ function (configService) {
          return configService.load().catch(() => null);
        },
        challengeProcess: /* @ngInject */ function (
          challenge,
          config,
          process,
          advancedCodeChallengeProcessService,
        ) {
          return challenge
            ? advancedCodeChallengeProcessService.create(challenge, process)
            : null;
        },
      },
      onExit: /* @ngInject */ function (challengeProcess) {
        return challengeProcess && challengeProcess.onExit();
      },
      views: {
        '@assessments': {
          template: advancedCodeChallengeTemplate,
          controller: 'AdvancedCodeChallengeCtrl as $ctrl',
        },
      },
    });
  })

  .controller(
    'AdvancedCodeChallengeCtrl',
    function AdvancedCodeChallengeCtrl(
      $scope,
      process,
      challenge,
      challengeProcess,
      Solution,
      appAlert,
      $timeout,
      bufferedSaveHelper,
      $state,
      multiFileChallengeService,
      codemirrorOptions,
      CodeFile,
      AdvancedCodeSolutionFile,
      $q,
      tracker,
      attachDialog,
      attachService,
      challengeSubmittingDialog,
      challengeRouteInteractHelper,
      $log,
    ) {
      const ctrl = this;

      ctrl.challenge = challenge;
      ctrl.$onInit = () => {
        const challengeItem =
          process.assessmentResult.getChallengeItem(challenge);
        if (!challengeItem) {
          $log.error(
            'Invariant violation: challengeItem was unexpectedly undefined in AdvancedCodeChallengeCtrl',
          );
          return;
        }

        ctrl.challenge = angular.extend(ctrl.challenge, {
          position: challengeItem.position,
        });
      };

      ctrl.process = challengeProcess;
      ctrl.next = process.next;
      ctrl.previous = process.previous;

      const saveSolution = bufferedSaveHelper(challengeProcess.autosave);
      ctrl.saveSolution = saveSolution;

      const hasPersistedLayoutState = (options) => {
        const keys = Object.keys(options || {});
        return keys.some((key) => /\$(tabset|tabindex|active)$/i.test(key));
      };

      let hasSavedLayoutOptions = hasPersistedLayoutState(
        challengeProcess.solution && challengeProcess.solution.options,
      );

      Object.defineProperties(ctrl, {
        readOnly: {
          get() {
            return process.readOnly;
          },
        },
        restricted: {
          get() {
            return process.restricted;
          },
        },
      });

      const challengeConfig = challengeProcess.mfcChallengeConfig();

      const hasChangedSinceSubmission = () => {
        const solution = challengeProcess.solution;
        return !!(
          solution &&
          !(
            solution.isSubmitted() &&
            solution.submissionHash === solution.generateSubmissionHash()
          )
        );
      };

      const hasFailedSubmissionAttempts = () => {
        const solution = challengeProcess.solution;
        return solution && solution.hasFailedSubmissionAttempts();
      };

      function afterInitSolution() {
        if (challengeProcess.fd) {
          const data = challengeProcess.fd.data;
          // restore nested models
          if (data.files && data.files.length) {
            data.files = data.files.map((val) =>
              AdvancedCodeSolutionFile.createInstance(val),
            );

            CodeFile.configureAccessLevels(data.files);
            const lockedLayout = challengeProcess.challenge.lockedLayout();
            const shouldForceInitialLayout =
              !lockedLayout && !hasSavedLayoutOptions;
            // also configure the default open files
            AdvancedCodeSolutionFile.configureInitialLayout(data.files, {
              mfcs: ctrl,
              always: shouldForceInitialLayout,
              lockedLayout,
            });
            Solution.configureInitialLayout(ctrl, {
              always: shouldForceInitialLayout,
              lockedLayout,
            });
          }

          multiFileChallengeService.restoreOpenFiles(ctrl);

          challengeProcess.fd.isDiff = isSolutionFilesDiff;
        }

        // assume we've submitted if we can
        ctrl.didSubmit =
          !hasFailedSubmissionAttempts() && !hasChangedSinceSubmission();
      }

      challengeProcess.afterInitSolution = afterInitSolution;

      ctrl.primaryIsPreview = () => !ctrl.didPreview && !ctrl.expired;
      ctrl.primaryIsTests = () =>
        ctrl.didPreview && !ctrl.passedTests && !ctrl.expired;
      ctrl.primaryIsSubmit = () =>
        ctrl.expired ||
        (ctrl.didPreview &&
          (ctrl.passedTests || !ctrl.challenge.candidateTestsEnabled));
      ctrl.showSubmitNext = () => {
        return (
          ctrl.didSubmit &&
          !ctrl.expired &&
          ((challenge.submissionFeedback && !hasFailedSubmissionAttempts()) ||
            !hasChangedSinceSubmission())
        );
      };

      ctrl.setExpired = (expired) => {
        if (expired) {
          ctrl.expired = ctrl.didSubmit = true;
          ctrl.submitLabel = process.nextLabel();
          ctrl.submitTooltip = `${process.nextIsChallenge() ? 'Continue with' : 'Complete'} your assessment`;
        }
      };

      const updateSubmissionStatus = () => {
        ctrl.submitLabel = 'Submit';
        ctrl.submitTooltip =
          'Submits your code for scoring. You can still modify your solution while there is time left on your assessment.';
        if (challenge.limitSubmissionAttempts) {
          const remaining = challengeProcess.solution
            ? challengeProcess.solution.remainingAttempts()
            : challenge.limitSubmissionAttempts;
          if (remaining) {
            if (remaining < 2) {
              ctrl.submitLabel = 'Final Submit';
              ctrl.submitTooltip =
                'Submits your code for final scoring. You will no longer be able to modify your solution.';
            } else {
              ctrl.submitLabel = `Submit (${remaining} remaining)`;
            }
          } else {
            ctrl.expirationReason = 'submission limit reached';
            ctrl.setExpired(true);
          }
        }
      };
      updateSubmissionStatus();

      function setupMFCS(useExternalIde) {
        const docsAdditionalArticles = [
          {
            icon: 'help',
            label: 'Debugging Tips',
            path: 'docs/debugging',
            docsArticleId:
              'for-candidates/advanced-challenge-ide/debugging-tips',
          },
          {
            icon: `lang-${challenge.runConfig.language}`,
            label: 'Testing Framework',
            path: 'docs/framework',
            docsArticleId: `reference/languages/${challenge.runConfig.language}/${challenge.runConfig.testFramework}`,
          },
        ];
        if (challenge.externalIdeEnabled()) {
          docsAdditionalArticles.push({
            icon: `help`,
            label: 'Use Your Own IDE',
            path: 'docs/external-ide',
            docsArticleId: 'for-candidates/advanced-challenge-ide/external-ide',
          });
        }

        multiFileChallengeService.create({
          svc: ctrl,
          enableAiAgent: challengeProcess.challenge.showAiAgentToCandidates,
          challenge: challengeProcess.challenge,
          solution: challengeProcess.solution,
          docsArticleId: 'for-candidates/advanced-challenge-ide/summary',
          docsAdditionalArticles: docsAdditionalArticles,
          challengeConfig,
          toolbarTemplate: advancedCodeChallengeFileToolbar,
          afterFileChanges: saveSolution,
          editChallengeEditorTools(svc) {
            // inserts above help
            insertBefore(
              svc.challengeEditorTools,
              svc.docsArticleFile,
              createInteractParticipantsTab(process),
            );
          },
        });

        // Minor hack to enable using the same toolbar code here and in the hire app
        ctrl.mfc = ctrl;

        // disables add button when using attach
        const addProps = {
          disabled: {
            get() {
              return ctrl.process.usingAttach;
            },
          },
          hidden: {
            get() {
              return process.readOnly;
            },
          },
        };
        Object.defineProperties(ctrl.actions[0], addProps);
        Object.defineProperties(ctrl.actions[1], addProps);

        ctrl.privilegedMode = 'none';

        ctrl.runResponse =
          ctrl.runResponse || challengeProcess.solution.getRunResponse();

        ctrl.templates = {
          fileMenu: advancedCodeChallengeFileMenu,
          deletedMenu: mfcDeletedFileMenu,
        };

        // initializes file drag-and-drop via MultiFileService
        if (!challenge.lockedLayout()) {
          ctrl.setupDrop($scope);
        }
        $scope.$on('$destroy', ctrl.destroy);

        ctrl.didPreview =
          !challenge.webPreviews() ||
          challengeProcess.solution.attempted() ||
          (ctrl.webPreviewFile.tabset && ctrl.webPreviewFile.active);
        ctrl.showWebPreview = () => {
          ctrl.didPreview = true;
          ctrl.clickFile(ctrl.webPreviewFile);
        };
        ctrl.passedTests = challengeProcess.solution.passed();
        let lastRunFileContents = {};
        const updateLastRunFileContents = () => {
          lastRunFileContents = {};
          const files = challengeProcess.solution.files || [];
          files.forEach((f) => {
            lastRunFileContents[f.path] = f.contents;
          });
        };
        ctrl.runTests = () => {
          if (ctrl.expired || !challenge.candidateTestsEnabled) return false;
          ctrl.didPreview = true;
          challengeProcess.setResponse({ result: false });
          challengeProcess.startRun();
          return $q
            .all([
              // track an attempted run
              challengeProcess.autosave(`initTest`).catch(() => {
                /* ignore errors */
              }),
              // simultaneously start running the code
              ctrl.run().catch((e) => {
                if (e && e.canceled) {
                  challengeProcess.autosave(`cancelTest`);
                } else {
                  challengeProcess.autosave(`errorTest`);
                }
                return $q.reject(e);
              }),
            ])
            .then(([, response]) => challengeProcess.logTest(response))
            .then(() => {
              ctrl.passedTests = challengeProcess.solution.passed();
              ctrl.didSubmit = false;
              updateLastRunFileContents();
            })
            .finally(challengeProcess.endRun);
        };
        ctrl.submitSolution = (autoNext = true) => {
          const handleAutoNext = () => {
            ctrl.$allowNext = true;
            if (autoNext) {
              challengeProcess.fd.finish();
              ctrl.next();
            }
          };

          if (ctrl.expired) {
            ctrl.didSubmit = true;
            handleAutoNext();
            ctrl.endSubmitSolution();
            return $q.resolve();
          }

          if (ctrl.running) {
            // don't run multiple times
            return $q.reject();
          }

          ctrl.startSubmitSolution();
          ctrl.running = ctrl.submitting = true;
          return challengeSubmittingDialog
            .open({
              solution: challengeProcess.solution,
              saveSolution,
              afterSubmit: () => {
                process.refreshStageStatuses();
                ctrl.endSubmitSolution();
              },
              expired: ctrl.expired,
              warn: !autoNext,
              nextLabel: process.nextActionLabel(),
            })
            .then((shouldReview) => {
              appAlert.clear();
              ctrl.didSubmit =
                !shouldReview ||
                (!ctrl.expired &&
                  !hasFailedSubmissionAttempts() &&
                  !hasChangedSinceSubmission());
              if (shouldReview) {
                updateLastRunFileContents();
                // don't allow moving forward
                return $q.reject();
              } else {
                handleAutoNext();
              }
            })
            .finally(() => {
              ctrl.endSubmitSolution();
              updateSubmissionStatus();
              ctrl.running = ctrl.submitting = false;
            });
        };

        ctrl.showSubmissionFeedback = () => {
          challengeSubmittingDialog.open({
            solution: challengeProcess.solution,
            expired: ctrl.expired,
            onlyShowResults: true,
            nextLabel: process.nextActionLabel(),
          });
        };

        const requireSubmit = () => {
          return (
            !ctrl.$allowNext && // special flag that means we've just submitted, just let the user pass
            !process.assessmentResult.isClosed() && // always allow transition if closed
            challengeProcess.solution && // user didn't even start
            challengeProcess.solution.remainingAttempts() && // user still has attempts
            !process.restricted && // we're not in a restricted editing mode
            !ctrl.expired && // the challenge didn't expire
            // require submit if not submitted at all OR we have limited attempts and submission failure messages
            (!ctrl.didSubmit ||
              (challenge.limitSubmissionAttempts &&
                hasFailedSubmissionAttempts()) ||
              hasChangedSinceSubmission())
          );
        };

        $scope.$on(
          '$stateChangeStart',
          (event, toState, toParams, fromState, fromParams, options) => {
            // capture and prevent changing the page if we're moving to another challenge,
            // and we've not already correctly submitted the result
            if (
              toState.name !== 'error' &&
              toState.name !== 'assessments.welcome' &&
              requireSubmit()
            ) {
              event.preventDefault();
              ctrl.submitSolution(false).then(() => {
                challengeProcess.fd && challengeProcess.fd.finish();
                $state.go(toState, toParams, options);
              });
            }
          },
        );

        $scope.$on(
          `socket:model.updated:Solution:${challengeProcess.solution.id}`,
          updateSubmissionStatus,
        );

        $scope.$watch(
          () => process.editMode,
          (newVal, oldVal) => {
            if (newVal !== oldVal) {
              ctrl.refreshOnFilesChanged();
            }
          },
        );

        challengeRouteInteractHelper.init(ctrl, process, $scope);

        const startInteract = () => {
          ctrl.startInteract(
            challengeProcess.firebaseRef,
            process.liveInterview,
          );
          challengeProcess.interact = ctrl.interact;
        };
        $scope.$on('liveInterviewStarted', startInteract);
        if (process.liveInterviewActive) startInteract();

        ctrl.on('fileChange', () => {
          ctrl.saveSolution();
          const solution = challengeProcess.solution;
          ctrl.didPreview = ctrl.didPreview || solution.attempted();
          const files = solution.files || [];
          ctrl.hasFileChanges =
            Object.keys(lastRunFileContents).length !== files.length ||
            files.some(
              (f) => !f.encrypted && lastRunFileContents[f.path] !== f.contents,
            );
          ctrl.passedTests = solution.passed() && !ctrl.hasFileChanges;
          ctrl.didSubmit = ctrl.didSubmit && !hasChangedSinceSubmission();
        });

        let nonFileTabMoved = false;
        ctrl.onTabMoved = (file) => {
          if (!nonFileTabMoved && !file.path) {
            nonFileTabMoved = true;
          }
        };

        process.refreshOnFilesChanged = (force) => {
          CodeFile.configureAccessLevels(challengeProcess.solution.files);
          ctrl.refreshOnFilesChanged();
          if (force) {
            multiFileChallengeService.restoreOpenFiles(ctrl);
          }
        };

        ctrl.attachTooltip = () => {
          return challengeProcess.usingAttach
            ? 'Revert to using the web editor'
            : 'Open this challenge in any IDE or other editor for solving locally';
        };

        let attachChannelService;
        let previousFilesLayout;
        const attachFilesLayout = [
          [challengeConfig[0], 'topLeft', 0, true],
          [challengeConfig[1], 'topLeft', 1],
          [ctrl.runnerFrameFile, 'topRight', 0, true],
          [ctrl.webPreviewFile, 'bottomRight', 0, true],
        ];

        const setOpenFiles = (layout) => {
          ctrl.openFiles = layout
            .filter(([f]) => f && !f.hidden)
            .map(([f, tabset, tabindex, active]) => {
              f.tabset = tabset;
              f.tabindex = tabindex;
              f.active = active;
              return f;
            });
          if (ctrl.fileLayout) ctrl.fileLayout.resetOpenFiles();
        };

        ctrl.toggleExternalIde = () => {
          const ATTACH_EVENT = 'Attach Connection Status Changed';
          const useAttach = !challengeProcess.usingAttach;
          tracker.trackEvent(ATTACH_EVENT, { state: 'waiting' });
          attachDialog
            .open(useAttach, ctrl.solution)
            .then(
              () => {
                challengeProcess.usingAttach = useAttach;
                if (useAttach) {
                  tracker.trackEvent(ATTACH_EVENT, { state: 'connected' });
                  process.usedAttach = true; // flag for the survey if they even click the button
                  if (!nonFileTabMoved) {
                    // if the user didn't re-arrange the workspace manually, let's clean up the UI to be more effective
                    previousFilesLayout = ctrl.openFiles.map((f) => [
                      f,
                      f.tabset,
                      f.tabindex,
                      f.active,
                    ]);
                    setOpenFiles(attachFilesLayout);
                  } else {
                    previousFilesLayout = null;
                  }
                  challengeProcess.solution.usedExternalIde = true;
                  challengeProcess.solution.usingExternalIde = true;
                  attachChannelService = attachService.create(
                    ctrl.solution.challengeId,
                    $scope,
                  );

                  attachChannelService.subscribe('test', ctrl.runTests);
                  attachChannelService.subscribe(
                    'submit',
                    ctrl.submitSolution.bind(ctrl, true),
                  );

                  let testsDebounce;
                  const saveChanges = () => {
                    $scope.$applyAsync(() => {
                      ctrl.onFileChange({ force: true });
                      if (challengeProcess.autoRunTests) {
                        if (testsDebounce) {
                          $timeout.cancel(testsDebounce);
                        }
                        testsDebounce = $timeout(() => {
                          ctrl.isAutoRun = true;
                          ctrl.runTests();
                        }, 250);
                      }
                    });
                  };

                  // due to the delayed nature, creating or updating a file is effectively the same process
                  const addOrUpdate = (msg) => {
                    const { path, contents } = msg.data;
                    ctrl.createFile({ path, contents }, false, false);
                    saveChanges();
                  };
                  attachChannelService.subscribe('file_added', addOrUpdate);
                  attachChannelService.subscribe('file_changed', addOrUpdate);

                  attachChannelService.subscribe('file_removed', ({ data }) => {
                    const f = ctrl.findFile(data.path);
                    if (f) {
                      ctrl.delete(f);
                      saveChanges();
                    }
                  });

                  attachChannelService.subscribe('show_alert', ({ data }) => {
                    if (angular.isString(data.message)) {
                      appAlert.show(data.message, data.type);
                    }
                  });
                } else if (attachChannelService) {
                  tracker.trackEvent(ATTACH_EVENT, { state: 'disconnected' });
                  if (previousFilesLayout) {
                    setOpenFiles(previousFilesLayout);
                  }
                  challengeProcess.solution.usingExternalIde = false;
                  attachChannelService.destroy();
                } else {
                  // canceled
                  tracker.trackEvent(ATTACH_EVENT, { state: 'canceled' });
                }
              },
              () => {
                // canceled
                tracker.trackEvent(ATTACH_EVENT, { state: 'canceled' });
              },
            )
            .catch((err) => {
              tracker.trackEvent(ATTACH_EVENT, {
                state: 'errored',
                error: err,
              });
              return appAlert.modelError.with({
                prefix: 'Unable to initialize Attach:',
              })(err);
            });
        };

        ctrl.closeableFiles = challenge.canCloseTabs()
          ? true
          : [
              ctrl.ideSettingsFile,
              ctrl.docsArticleFile,
              ctrl.webPreviewConsoleFile,
            ];

        afterInitSolution();

        if (useExternalIde || challengeProcess.solution.usingExternalIde) {
          // open the dialog if we were previously using the IDE
          $timeout(ctrl.toggleExternalIde);
        }
      }

      ctrl.fileMenuClass = (file) => {
        // return the file-access icon for non-read-write files
        let menuClass = '';
        if (file) {
          if (file.$access !== 'readwrite') {
            menuClass += `file-access-${file.$access}`;
          }
        }
        return menuClass;
      };

      const buildCodeOfConductState = () => {
        const team = process.assessment && process.assessment.team;
        const enabled = !!(
          team &&
          team.hasFeature('codeOfConduct') &&
          challenge.cocEnabled
        );
        const rules = enabled ? challenge.codeOfConductRules() : [];
        rules.forEach((rule) => {
          rule.acknowledged = false;
        });
        return {
          enabled,
          rules,
          requireAcknowledgement:
            enabled && challenge.cocRequireAcknowledgement !== false,
        };
      };
      ctrl.codeOfConduct = buildCodeOfConductState();
      ctrl.codeOfConductAcknowledged = () => {
        if (!ctrl.codeOfConduct.enabled) return true;
        if (!ctrl.codeOfConduct.requireAcknowledgement) return true;
        return ctrl.codeOfConduct.rules.every((rule) => rule.acknowledged);
      };
      ctrl.unableToBeginChallenge = () =>
        ctrl.beginning || !ctrl.codeOfConductAcknowledged();

      if (challengeProcess.solution) {
        setupMFCS();
      } else {
        ctrl.codemirrorOpts = codemirrorOptions;
        ctrl.showIntro = true;
        ctrl.introDialogTemplate = introDialogTemplate;
        ctrl.beginChallenge = (useExternalIde) => {
          if (ctrl.unableToBeginChallenge()) return;
          ctrl.beginning = true;
          challengeProcess
            .beginChallenge()
            .then(() => {
              process.addSolution(challengeProcess.originalSolution);
              hasSavedLayoutOptions = hasPersistedLayoutState(
                challengeProcess.solution && challengeProcess.solution.options,
              );
              setupMFCS(useExternalIde);
              ctrl.showIntro = false;
            })
            .finally(() => {
              $timeout(() => {
                // delayed to let dialog close
                ctrl.beginning = false;
              }, 100);
            });
        };
      }

      challengeProcess.resaveAfterFail = () => saveSolution('resaveAfterFail');

      challengeProcess.onEnter($scope, ['AdvancedCodeSolutionFile']);
    },
  );
